import React, { useContext, useEffect } from 'react';
import { useLocation } from '@reach/router';
import { graphql } from 'gatsby';
import { Context } from '@components/Context';
import DashboardPageModalWrap from '@components/dashboard/components/DashboardPageModalContainer';
import PageContainerTemplate from '@components/dashboard/components/PageContainerTemplate';
import ForgotPassword from '@components/ForgotPassword';
import Layout from '@components/Layout';
import { NavContext } from '@components/navigation/Context';
import LoginLoader from '@components/shared/LoginLoader';
import { getSearchParameterByName } from '@utils/helpers';
import useLoggedInRedirect from '@utils/useLoggedInRedirect';
import useLogoutHandle from '@utils/useLogoutHandle';

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default function ForgotPasswordPage() {
  const { navDispatch } = useContext(NavContext);
  const { state } = useContext(Context);
  const { loggedIn } = state;
  const location = useLocation();
  const isAppClient = getSearchParameterByName('appClient', location) === 'true';
  const redirectFlag = useLoggedInRedirect(false, '', isAppClient);
  const handleLogout = useLogoutHandle({ navigateLink: '' });

  const SEO = {
    uid: 'forgot-password',
    title: 'Forgot Password'
  };

  useEffect(() => {
    if (loggedIn && isAppClient) {
      handleLogout();
    }
  }, [isAppClient, loggedIn]);

  useEffect(() => {
    navDispatch({ type: 'setShowingBanner', data: false });
  }, []);

  if (redirectFlag && !isAppClient) {
    return <LoginLoader />;
  }

  return (
    <Layout isVMS={true} SEO={SEO}>
      <DashboardPageModalWrap>
        <PageContainerTemplate padding="0">
          <ForgotPassword />
        </PageContainerTemplate>
      </DashboardPageModalWrap>
    </Layout>
  );
}
